import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Attribute } from '@app/shared/interfaces/Attribute';

@Component({
  selector: 'app-attribute-children',
  templateUrl: './attribute-children.component.html',
  styleUrls: ['./attribute-children.component.less'],
})
export class AttributeChildrenComponent implements OnInit {
  @Input() existedChildAttributes: any[] = [];
  @Input() formGroup: FormGroup;
  @Input() childAttributesToAdd: Attribute[] = [];
  @Output() childAttributesChanged = new EventEmitter();
  constructor() {}

  ngOnInit() {}

  AddChildAttribute() {
    this.childAttributesToAdd = [
      ...this.childAttributesToAdd,
      {
        Id: 0,
        Label: '',
        Name: '',
        Type: this.Type.value,
        AttributeOptions: [],
      },
    ];
    this.selectionChanged();
  }
  selectionChanged() {
    this.formGroup.markAsDirty();
    this.formGroup.markAsTouched();
    this.childAttributesChanged.emit(this.childAttributesToAdd);
  }
  get Type() {
    return this.formGroup.controls['Type'] as FormControl;
  }
}
